import {Link} from "react-router";
import type {FC, ReactNode} from "react";

type Props = {
    path: string | null
    disabled?: boolean
    children?: ReactNode
    className?: string
    fallbackComponent?: 'span' | 'div'
};
export const MLink: FC<Props> = ({path, disabled, children, className, fallbackComponent}) => {
    const clsName = 'mithra-link' + (className ? ` ${className}` : ``)
    if (disabled || !path) {
        if (fallbackComponent === 'span') {
            return <span className={clsName}>{children}</span>
        } else if (fallbackComponent === 'div') {
            return <span className={clsName}>{children}</span>
        } else {
            return children;
        }
    }
    return <Link className={clsName} to={path}>{children}</Link>
}
